<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>
    <v-card class="card-outline force-remove-box">
      <v-card-text class="force-custom-bg">
        <v-container fluid>
          <v-row dense class="mb-5 text-center text-md-left subtitle-1">
            <v-col cols="12" lg="4">
              <strong
                >Total commission:
                <v-avatar :size="$gold_coin_sm"
                  ><img :src="$goldCoinWhite" alt="coin"
                /></v-avatar>
                {{ dt_total_commission | toNumberWithDecimal }}</strong
              >
            </v-col>
            <!-- <v-col cols="12" lg="3">
              <strong
                >Previous week commission:
                <v-avatar :size="$gold_coin_sm"
                  ><img :src="$goldCoinWhite" alt="coin"
                /></v-avatar>
                {{ previousWeek  | toNumberWithDecimal }}</strong
              >
            </v-col> -->
            <v-col cols="12" lg="4">
              <strong
                >Weekly commission:
                <v-avatar :size="$gold_coin_sm"
                  ><img :src="$goldCoinWhite" alt="coin"
                /></v-avatar>
                {{ currentWeek  | toNumberWithDecimal }}</strong
              >
            </v-col>
            <v-col cols="12" lg="4">
              <strong
                >Daily commission:
                <v-avatar :size="$gold_coin_sm"
                  ><img :src="$goldCoinWhite" alt="coin"
                /></v-avatar>
                {{ dailycom  | toNumberWithDecimal }}</strong
              >
            </v-col>
          </v-row>
          <v-row dense class="d-flex justify-end mt-n2">
            <!-- <v-col cols="12" md="2">
                            <v-text-field clearable dense outlined v-model="dt_searchQuery" label="Search"></v-text-field>
                        </v-col> -->
            <v-col cols="12" lg="2" class="span-label" :class="($hideifuserisSupervisor())">
              <!-- <span v-html="setManagerSupervisorName()"></span> -->
              <span>{{ this.$agentName }}</span>
              <agent-credit-autocomplete-template
                ref="agent_autocomplete"
              ></agent-credit-autocomplete-template>
            </v-col>

            <v-col cols="12" lg="2" class="span-label">
              <span>Date from</span>
              <v-text-field
                clearable
                dense
                hide-details
                class="regular-field"
                v-model="dt_DateFrom"
                label="Date from"
                type="date"
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" class="span-label">
              <span>Date to</span>
              <v-text-field
                clearable
                dense
                hide-details
                class="regular-field"
                v-model="dt_DateTo"
                label="Date to"
                type="date"
              ></v-text-field>
            </v-col>

            <v-col
              cols="12"
              lg="2"
              class="mt-7" style="padding-top:5px;"
            >
              <v-btn
                color="custom_info"
                class="float-right btn-block"
                @click="getDataFromApi()"
                >Search</v-btn
              >
            </v-col>

            <!-- <v-col cols="12" md="3" lg="3" xl="2">
                            <v-btn color="info" class="float-right btn-block" @click="modalForm">Add area</v-btn>
                        </v-col> -->

            <v-col cols="12" class="mt-2">
              <v-data-table
                class="custom-header-color table-bordered table-striped"
                :headers="dt_headers"
                :items="dt_resultlist"
                item-key="id"
                :loading="dt_loading"
                :options.sync="dt_options"
                :server-items-length="dt_totalResult"
              >
                <template v-slot:[`item.totalcommission`]="{ item }">
                  <v-avatar :size="$gold_coin_sm"
                    ><img :src="$goldCoinWhite" alt="coin"
                  /></v-avatar>
                  {{ item.totalcommission | toNumberWithDecimal }}</template
                >
                <template v-slot:[`item.level`]="{ item }">
                  L{{ item.level }}</template
                >
              </v-data-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
export default {
  data() {
    return {
      schedules: [
        { name: "Sunday" },
        { name: "Monday" },
        { name: "Tuesday" },
        { name: "Wednesday" },
        { name: "Thursday" },
        { name: "Friday" },
        { name: "Saturday" },
      ],
      dialogForm: false,
      isLoadingBtn: false,
      isLoadingBtnDelete: false,
      formerror: {},
      modalUpdate: false,
      dt_headers: [
        // {
        //   text: "ID",
        //   value: "id",
        //   name: "id",
        //   sortable: true,
        //   searchable: false,
        //   align: " d-none",
        // },
        {
          text: this.$agentName,
          value: "manager",
          name: "manager",
          sortable: false,
          searchable: false,
        },
        {
          text: "Level",
          value: "level",
          name: "level",
          sortable: false,
          searchable: false,
        },
        {
          text: "Total commission",
          value: "totalcommission",
          name: "totalcommission",
          sortable: false,
          searchable: false,
        },
        // { text: 'Manager', value: 'name', name: 'name', sortable: false, searchable: false},
        // { text: 'Contact #', value: 'name', name: 'name', sortable: false, searchable: false},
        // { text: 'Bet transaction', value: 'name', name: 'name', sortable: false, searchable: false},
        // { text: 'Daily player cash-ins', value: 'address', name: 'address', sortable: false, searchable: false},
        // { text: 'Daily player cash-outs', value: 'address', name: 'address', sortable: false, searchable: false},
        // { text: 'Daily player payouts', value: 'address', name: 'address', sortable: false, searchable: false},
      ],
      dt_options: {},
      dt_columns: {},
      dt_totalResult: 0,
      dt_searchInput: "",
      dt_searchQuery: "",
      dt_searchAgentId: "",
      agent_id:
        this.$store.state.currentUser.agent_data.level != 0
          ? this.$store.state.currentUser.agent_data.id
          : null,
      dt_DateFrom: this.$moment().format("YYYY-MM-DD"),
      dt_DateTo: this.$moment().format("YYYY-MM-DD"),

      dt_resultlist: [],
      dt_loading: true,
      dt_itemsPerPage: 50,
      dt_reload: "",
      dt_total_commission: "",
      previousWeek: "",
      currentWeek: "",
      dailycom: "",
      form: new this.$Form({
        id: null,
        name: null,
        address: null,
      }),
    };
  },
  methods: {
    setManagerSupervisorName(){
        if(this.$store.state.currentUser.agent_data.level == 0){
            return 'Manager';
        }
        else if(this.$store.state.currentUser.agent_data.level == 1){
            return 'Supervisor';
        }
        else if(this.$store.state.currentUser.agent_data.level == 2){
            return 'Supervisor';
        }
        else{
            return 'Manager';
        }
    },
    schedule_draw_format(val) {
      // let data = [];
      // val = JSON.parse(val);
      // val.forEach(element => {
      //     data.push(element.name);
      // });
      // return data.join(', ');
    },
    modalForm() {
      this.modalUpdate = false;
      this.form.reset();
      this.dialogForm = true;
    },
    copyClipboard(data) {
      data = data.split(" / ");
    },
    async newData() {
      this.isLoadingBtn = true;
      this.form
        .post(this.$_CONFIG.api("API_AREAS"))
        .then(({ data }) => {
          this.isLoadingBtn = false;
          this.getDataFromApi();
          this.dialogForm = false;
          // this.$Swal.fire(
          //   "Success!",
          //   "Record has been successfully added.",
          //   "success"
          // );
          this.$toast.fire({ icon: 'success', title: "Record has been successfully added" });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async findData(data) {
      this.formerror = {};
      this.form.reset();
      this.form.fill(data);
      this.modalUpdate = true;
      this.dialogForm = true;
    },
    async updateData() {
      this.isLoadingBtn = true;
      this.form
        .put(this.$_CONFIG.api("API_AREAS") + "/" + this.form.id)
        .then(() => {
          this.isLoadingBtn = false;
          this.dialogForm = false;
          this.getDataFromApi();
          this.$toast.fire({
            icon: "success",
            title: "Record has been successfully updated.",
          });
        })
        .catch((error) => {
          this.isLoadingBtn = false;
          this.formerror = error.response.data.errors;
          this.$toast.fire({ icon: "error", title: "Something went wrong!" });
        });
    },
    async deleteData(id) {
      this.isLoadingBtnDelete = true;
      if (
        await this.$refs.confirm.open(
          "Confirm",
          "Are you sure you want to delete all record?"
        )
      ) {
        this.$axios
          .post(this.$_CONFIG.api() + "/destroyzone", { zone: id })
          .then(() => {
            this.isLoadingBtnDelete = false;
            this.dialogForm = false;
            this.getDataFromApi();
            this.$toast.fire({
              icon: "success",
              title: "Record has been successfully deleted.",
            });
          })
          .catch(() => {
            this.isLoadingBtnDelete = false;
            this.$toast.fire({ icon: "error", title: "Something went wrong!" });
          });
      } else {
        this.isLoadingBtnDelete = false;
      }
    },
    paramsfilter() {
      let subagent =
        this.$store.state.currentUser.agent_data.level != 0
          ? this.$store.state.currentUser.agent_data.id
          : null;
      try {
        if (this.$refs.agent_autocomplete.autocomplete_model.id) {
          subagent = this.$refs.agent_autocomplete.autocomplete_model.id;
        }
      } catch (error) {
        subagent =
          this.$store.state.currentUser.agent_data.level != 0
            ? this.$store.state.currentUser.agent_data.id
            : null;
      }
      return {
        ...this.dt_options,
        query: this.dt_searchQuery,
        agent_id: subagent,
        filterDateFrom: this.dt_DateFrom,
        filterDateTo: this.dt_DateTo,
      };
    },
    async getDataFromApi() {
      this.dt_loading = true;
      var paramsfilter = await this.paramsfilter();
      this.dt_columns = await this.$YajraDT.setHeader(this.dt_headers);
      let params = await this.$YajraDT.params(
        paramsfilter,
        this.dt_options,
        this.dt_itemsPerPage,
        this.dt_columns
      );
      let apiPath = (await this.$_CONFIG.api()) + "/listcommissionagent";

      await this.$axios
        .post(apiPath + "?" + this.$.param(params))
        .then((res) => {
          if (this.dt_totalResult != res.data.recordsFiltered) {
            this.dt_options.page = 1;
          }

          this.dt_resultlist = res.data.data;
          this.dt_totalResult = res.data.recordsFiltered;
          this.dt_total_commission = res.data.totalcommission;
          // this.previousWeek  = res.data.previousWeek;
          this.currentWeek  = res.data.currentWeek;
          this.dailycom  = res.data.dailycom;

          // this.dt_resultlist = [];
          // this.dt_totalResult = 0;
          this.dt_loading = false;
        })
        .catch((err) => {
          this.dt_loading = false;
          console.log(err);
        });

      var unwatch = this.$watch(
        "dt_options.page",
        function(newValue, oldValue) {
          this.getDataFromApi();
          unwatch();
        },
        { deep: true }
      );
    },
  },
  created() {
    this.getDataFromApi();
  },
  mounted() {},
};
</script>
<style scoped></style>